/**
 * Bold centred tagline. Transparent by default so the hero photo shows behind it.
 * `marginTop` / `paddingY` let it be positioned independently of ChevronSteps.
 * `width` applies from 768px up (centred), matching ChevronSteps. Purely visual.
 */
export default function TaglineBar({
  text = "YOUR 5-STEP PATH TO SAFE DATING",
  width = "100%",
  marginTop = 0,
  marginBottom = 0,
  paddingY = "clamp(10px, 1vw, 14px)",
  background = "transparent",
  className = "",
}) {
  return (
    <div
      data-testid="tagline-bar"
      className={`relative z-10 mx-auto w-full md:w-[var(--tb-width)] px-4 text-center ${className}`}
      style={{
        "--tb-width": width,
        marginTop,
        marginBottom,
        paddingTop: paddingY,
        paddingBottom: paddingY,
        background,
      }}
    >
      <h2
        className="text-white font-bold uppercase leading-tight tracking-[0.04em]"
        style={{ fontFamily: "'Roboto', 'IBM Plex Sans', sans-serif", fontSize: "clamp(16px, 2.2vw, 30px)" }}
      >
        {text}
      </h2>
    </div>
  );
}
